import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as license from "../../../../constants/license";
import * as globalActions from "../../../../actions/globalActions";
import * as licenseActions from "../../../../actions/licenseActions";
import * as keyboardActions from "../../../../actions/virtualKeyboardActions";

import imgLicenseLock from "../../../../resources/img/svgicons/license2.svg";
import imgSkip from "../../../../resources/img/svgicons/skip.svg";
import imgNext from "../../../../resources/img/svgicons/arrow-right-circle.svg";
import Button, {BUTTON_SMALL} from "../../../global/generic/Button";

class LicenseIdentificationForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            companyId: this.props.companyId !== null ? this.props.companyId : "",
            userId: this.props.userId !== null ? this.props.userId : ""
        };
    }

    componentDidMount() {
        window.jQuery("#redlike-licensing-identification-form-company-id").on(
            "change",
            function (event) {
                if (event.target.value.trim() !== this.state.companyId && event.target.value.trim().length <= 8) {
                    this.setState({companyId: event.target.value.trim()});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-identification-form-user-id").on(
            "change",
            function (event) {
                if (event.target.value.trim() !== this.state.userId && event.target.value.trim().length <= 8) {
                    this.setState({userId: event.target.value.trim()});
                }
            }.bind(this)
        );
    }

    componentWillUnmount() {
        window.jQuery("#redlike-licensing-identification-form-company-id").unbind("change");
        window.jQuery("#redlike-licensing-identification-form-user-id").unbind("change");
    }

    handleCompanyInputChange = (event) => {
        if (event.target.value.trim().length <= 8) {
            this.setState({
                companyId: event.target.value
            });
        }
    };

    handleUserInputChange = (event) => {
        if (event.target.value.trim().length <= 8) {
            this.setState({
                userId: event.target.value.trim()
            });
        }
    };

    handleConfirmCompanyFormClick = () => {
        if (this.state.companyId.length === 8 && this.state.userId.length === 8) {
            this.props.dispatchSetLicenseIdentificationAction(this.state.companyId, this.state.userId);
        }
    };

    handleContinueToRedlikeClick = () => {
        this.props.dispatchStartSoftwareInitializationAction();
    };

    handleCompanyIdInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-identification-form-company-id"
            );
        }
    };

    handleUserIdInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-identification-form-user-id");
        }
    };

    getContinueButton = () => {
        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.continue" />}
                onClick={this.handleConfirmCompanyFormClick}
                svgBefore={imgNext}
                disabled={this.state.companyId.length !== 8 || this.state.userId.length !== 8}
            />
        );
    };

    getSkipNewLicenseButton = () => {
        if (this.props.setupSoftware || this.props.licenseStatus !== license.STATUS_VALID_LEASED_LICENSE) {
            return "";
        }

        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.skip" />}
                onClick={this.handleContinueToRedlikeClick}
                svgBefore={imgSkip}
            />
        );
    };

    render() {
        return (
            <div className="flex flex-column fill-flex-space flex-child">
                <div
                    className="col-11 fill-flex-space flex-child slim-scroll margin-bottom-10"
                    style={{
                        backgroundColor: "#0e3256",
                        marginLeft: "auto",
                        marginRight: "auto",
                        color: "white"
                    }}
                >
                    <div className="col-12 text-center margin-top-10 margin-bottom-10">
                        <Translate value="license.enterIdentificationKeys" />
                    </div>
                    <div className="license-already-activated">
                        <ReactSVG src={imgLicenseLock} className="svg-icon" alt="lock" />
                    </div>
                    <div className="col-12 color-primary flex margin-bottom-10">
                        <div className="col-5 flex flex-end">
                            <Translate value="license.companyId" />:
                        </div>
                        <div className="col-4">
                            <input
                                id="redlike-licensing-identification-form-company-id"
                                className="margin-left-30 color-black"
                                type="text"
                                value={this.state.companyId}
                                onChange={this.handleCompanyInputChange}
                                onFocus={this.handleCompanyIdInputFocus}
                            />
                        </div>
                    </div>
                    <div className="col-12 color-primary flex">
                        <div className="col-5 flex flex-end">
                            <Translate value="license.userId" />:
                        </div>
                        <div className="col-4">
                            <input
                                id="redlike-licensing-identification-form-user-id"
                                className="margin-left-30 color-black"
                                type="text"
                                value={this.state.userId}
                                onChange={this.handleUserInputChange}
                                onFocus={this.handleUserIdInputFocus}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12 flex flex-align-center flex-gap-3vh margin-bottom-10">
                    {this.getContinueButton()}
                    {this.getSkipNewLicenseButton()}
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        licenseStatus: store.license.licenseStatus,
        userId: store.license.userId,
        companyId: store.license.companyId,
        virtualKeyboardEnabled: store.settings.virtualKeyboardEnabled,
        keyboardState: store.virtualKeyboard.keyboardState
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartSoftwareInitializationAction: () => {
            dispatch(globalActions.startSoftwareInitialization());
        },
        dispatchSetLicenseIdentificationAction: (companyId, userId) => {
            dispatch(licenseActions.setLicenseIdentification(companyId, userId));
        },
        dispatchSetUniversalKeyboardStateAction: (state, selector) => {
            dispatch(keyboardActions.setUniversalKeyboardState(state, selector));
        }
    };
};

export default LicenseIdentificationForm = connect(mapStoreToProps, mapDispatchToProps)(LicenseIdentificationForm);
